import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import About from "./About";
import Topblog from "./Topblog";
import Requestform from "../Registration/RequestForm";
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop:'2rem',
        padding:'30px',
        backgroundColor: theme.palette.background.paper
    }
}));

export default function SimpleTabs(props) {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
const {category} = props.location.state
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className={classes.root}>
            <AppBar position="static">
                <Tabs
                    value={value}
                    style={{ backgroundColor: "white", color: "black" }}
                    TabIndicatorProps={{ style: { background: "black" } }}
                    onChange={handleChange}
                    scrollButtons="auto"
                    variant="scrollable"
                    aria-label="simple tabs example"
                    scrollButtons="on"
                >
                    <Tab label="About Service" {...a11yProps(0)} />
                    <Tab label="Top Blogs" {...a11yProps(1)} />
                    <Tab label="Book Appointment" {...a11yProps(2)} />
                </Tabs>
            </AppBar>
            <TabPanel value={value} index={0}>
                <About category={category}/>
            </TabPanel>
            <TabPanel value={value} index={1}>
                <Topblog />
            </TabPanel>
            <TabPanel value={value} index={2} style={{marginTop:'-10vh'}}>
                <Requestform category={category}/>
            </TabPanel>
        </div>
    );
}
